import { CheckCircleOutline, DoDisturbOn, Label } from "@mui/icons-material";
import {
    Button,
    Container,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Switch,
    TextField,
    Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { useFormik } from "formik";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import { FormHeading } from "../../Layouts/Heading";
import {
    adderReset,
    GetAllAdders,
    GetSingleAdderMethod,
    UpdateAdderMethod,
    UpdateAdderStatus,
} from "../../Redux/AddersSlicev2/AddersSlicev2";
import { Link, useLocation, useNavigate } from "react-router-dom";

const EditAdderv2 = () => {
    const { id } = useParams();

    const { adder, isLoading, isError, errors, isSuccess } = useSelector(
        (state) => state.addersv2
    );

    const AdderVal = adder?.data || [];

    // console.log(navigate("/"))
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const CallNotificationMethod = async () => {
        toast.success("The data has been modified successfully");
        await dispatch(adderReset());
        await navigate("/dashboard/adders/v2");
    };

    const formik = useFormik({
        initialValues: {
            id: "",
            name: "",
            is_active: true,
            status: 0,
        },
        onSubmit: async (values) => {
            if (values.is_active.length > 0)
            {
                values.is_active = 1
            } else {
                values.is_active = 0
            }

            await dispatch(UpdateAdderMethod(values));
            await CallNotificationMethod();
        },
    });

    useEffect(() => {
        const GetAdderData = async () => {
            await dispatch(GetSingleAdderMethod(id));
            await dispatch(adderReset());
        };
        GetAdderData();
    }, [dispatch, id]);

    useEffect(() => {
        if (AdderVal) {
            console.log(AdderVal)
            formik.values.id = AdderVal?.id || "";
            formik.values.name = AdderVal?.name || "";
            formik.values.is_active = AdderVal?.is_active === 1 ? true : false;
            formik.values.status = AdderVal?.status || 0;
        }
    }, [AdderVal]);

    useEffect(() => {
        if (isError) {
            if (errors) {
                if (errors.length < 8) {
                    Object.keys(errors).forEach((key) => {
                        let error = errors[key][0];
                        toast.error(error);
                    });
                } else {
                    toast.error(errors);
                }
            }
            const reset = async () => {
                await dispatch(adderReset());
            };
            // reset();
        }
    }, [isError]);

    return (
        <>
            {isLoading && <LoadingAnimation />}
            {!isLoading && (
                <>
                    <Container>
                        <FormHeading> Edit Adder </FormHeading>
                        <form onSubmit={formik.handleSubmit}>
                            <Grid mt={2} container columns={12} spacing={2}>
                                <Grid item mb={1} xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        id="name"
                                        name="name"
                                        label="Name"
                                        value={formik.values.name}
                                        onChange={formik.handleChange}
                                    />
                                </Grid>
                                <Grid item mb={1} xs={12} md={6}>
                                    <InputLabel> Active ? </InputLabel>
                                    <Switch
                                        id="is_active"
                                        name="is_active"
                                        checked={formik.values.is_active}
                                        value={formik.values.is_active}
                                        onChange={formik.handleChange}
                                        inputProps={{ "aria-label": "controlled" }}
                                    />
                                </Grid>
                            </Grid>

                            <PrimaryButton fullWidth type="submit">
                                {isLoading ? "Loading..." : "Edit"}
                            </PrimaryButton>
                        </form>
                    </Container>
                </>
            )}
        </>
    );
};

export default EditAdderv2;
